import React, { useEffect, useState, useCallback } from 'react';
import { buscarAliquotaSimples, registrarAliquotaSimples } from '../../services/nf';

/* ── Alíquota do Simples Nacional mês a mês ──
   No Simples a alíquota efetiva muda todo mês. O histórico fica aqui; a 1ª
   emissão do mês pede para confirmar (ver ModalAliquotaMes, na emissão). */
const mesAno = (c) => `${c.slice(5)}/${c.slice(0, 4)}`;

function AliquotaSimplesMensal({ clienteId, className }) {
  const [dados, setDados] = useState(null);
  const [nova, setNova] = useState('');
  const [competencia, setCompetencia] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(() => buscarAliquotaSimples(clienteId)
    .then(r => { setDados(r); setCompetencia(c => c || r.mes); })
    .catch(e => setErro(e.message)), [clienteId]);
  useEffect(() => { carregar(); }, [carregar]);

  async function salvar() {
    setErro(''); setSalvando(true);
    try { await registrarAliquotaSimples(clienteId, { competencia, aliquota: Number(String(nova).replace(',', '.')) }); setNova(''); await carregar(); }
    catch (e) { setErro(e.message); } finally { setSalvando(false); }
  }

  if (!dados) return <p style={{ fontSize: 12.5, color: '#6B8CAE' }}>{erro || 'Carregando...'}</p>;
  return (
    <div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12 }}>
          Mês
          <input type="month" className={className} value={competencia} onChange={e => setCompetencia(e.target.value)} />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12 }}>
          Alíquota (%)
          <input type="number" step="0.01" min="0" className={className} value={nova} onChange={e => setNova(e.target.value)} placeholder="ex.: 6,54" />
        </label>
        <button type="button" onClick={salvar} disabled={salvando || nova === '' || !competencia}
          style={{ height: 36, padding: '0 14px', borderRadius: 8, border: '1px solid #0D1F3C', background: '#0D1F3C', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
          {salvando ? 'Salvando...' : 'Registrar'}
        </button>
      </div>
      {erro && <p style={{ color: '#b91c1c', fontSize: 12.5 }}>{erro}</p>}
      <p style={{ fontSize: 12, color: '#6B8CAE', margin: '8px 0 4px' }}>
        {dados.doMes ? `Alíquota de ${mesAno(dados.mes)}: ${dados.doMes.aliquota}%.` : `Ainda sem alíquota de ${mesAno(dados.mes)}: a 1ª nota do mês vai pedir para confirmar.`}
      </p>
      {dados.historico.length > 0 && (
        <table style={{ width: '100%', fontSize: 12.5, borderCollapse: 'collapse' }}>
          <thead><tr style={{ color: '#6B8CAE', textAlign: 'left' }}><th>Mês</th><th>Alíquota</th><th>Como</th><th>Por</th></tr></thead>
          <tbody>
            {dados.historico.slice(0, 12).map(h => (
              <tr key={h.competencia} style={{ borderTop: '1px solid #eef3f8' }}>
                <td>{mesAno(h.competencia)}</td><td>{h.aliquota}%</td><td>{h.mantida ? 'mantida do mês anterior' : 'informada'}</td><td>{h.informado_por || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AliquotaSimplesMensal;
